import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CheckListDto } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/lib/models/check-interface';
import { ChecksService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/lib/services/checks.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { PHBHPFeaturePackageInsitutionManagementService } from 'src/app/institution/ph-bhp-feature-package-insitution-management.service';

@Component({
  selector: 'hygiene-check-list',
  templateUrl: './hygiene-check-list.component.html',
  styleUrls: ['./hygiene-check-list.component.scss']
})
export class HygieneCheckListComponent implements OnInit, OnDestroy {

  public checkList: CheckListDto = { checkList: [], totalPages: 0, totalChecks: 0 };
  public checkListLoading: boolean = false;
  public page: number = 1;
  public institutionId: number;
  public isInstitutionConfigured: boolean = false;
  public subscriptionInstitution: Subscription;
  public reloadInterval: any;
  public filters: any = [
    { name: 'CHECK.FILTER.ALL', value: 'all' },
    { name: 'CHECK.FILTER.PROGRESS', value: 'progress' },
    { name: 'CHECK.FILTER.COMPLETE', value: 'complete' }
  ]
  public filterType: string = 'all';
  public checkListCounts: any = {
    all: 0,
    progress: 0,
    complete: 0
  }

  constructor(
    public config: AppConfig,
    private router: Router,
    public checksService: ChecksService,
    private layoutService: PHBHPLayoutPackageService,
    private institutionService: PHBHPFeaturePackageInsitutionManagementService,
  ) { }

  ngOnInit() {
    this.subscriptionInstitution = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
      if (!res) {
        this.router.navigateByUrl('dashboard');
        return;
      }
      this.institutionService.getInstitutionById(res).subscribe((institutionResponse) => {
        if ([4, 5, 6, 7].includes(institutionResponse[0].institution.packageID)) {
          this.institutionId = this.layoutService.institutionID;
          this.isInstitutionConfigured = true;
          this.loadCheckList();
        } else {
          this.router.navigateByUrl('dashboard');
          return;
        }
      });
    });

    if (!this.reloadInterval) {
      this.reloadInterval = setInterval(() => {
        const userData = localStorage.getItem('userData');
        const userDataJson = JSON.parse(userData);
        this.checksService.hasModifiedChecks(userDataJson['userId'], this.institutionId).subscribe((response: any) => {
          if (response.resultData) {
            this.loadCheckList();
          }
        });
      }, 30000);
    }

    if (this.layoutService.institutionID) {
      this.layoutService.showLoader = true;
      this.checksService.getWardsAndDepartments(this.layoutService.institutionID).subscribe((response: any) => {
        if (response && response["wardsDetails"] && response["wardsDetails"].length > 0) {
          this.isInstitutionConfigured = true;
          this.loadCheckList();
        } else {
          this.isInstitutionConfigured = false;
          this.layoutService.showLoader = false;
          clearInterval(this.reloadInterval);
        }
      }, (error) => { this.layoutService.showLoader = false; });
    }
  }

  ngOnDestroy() {
    this.subscriptionInstitution.unsubscribe();
    if (this.reloadInterval) {
      clearInterval(this.reloadInterval);
      this.reloadInterval = null;
    }
  }

  loadCheckList() {
    this.institutionId = this.layoutService.institutionID;
    if (!this.institutionId) {
      this.router.navigate(['/dashboard']);
      return;
    }

    // set localstorage
    localStorage.setItem('institutions', this.institutionId.toString());
    this.layoutService.showLoader = true;
    const userData = localStorage.getItem('userData');

    if (userData && this.institutionId) {
      const userDataJson = JSON.parse(userData);
      this.checksService.getChecks(userDataJson['userId'], this.institutionId, this.page, this.filterType).subscribe({
        next: (resp: any) => {
          if (resp && resp['checkList'].length > 0) {
            this.checkList = resp;
            localStorage.setItem('institutionName', this.checkList.checkList[0].institutionName);
            this.checksService.getChecksHeader(this.institutionId).subscribe(async (header: any) => {
              this.checkListCounts.all = header.total;
              this.checkListCounts.progress = header.progress;
              this.checkListCounts.complete = header.completed;
            });
          } else {
            if (this.page > 1) {
              this.page--;
              this.loadCheckList();
              return;
            } else {
              this.checkList.checkList = [];
              this.checkList.totalPages = 0;
            }
          }
          this.layoutService.showLoader = false;
        },
        error: () => {
          this.layoutService.showLoader = false;
          this.checkList.totalPages = 0;
        }
      });
    }
    else {
      this.checkListLoading = false;
      this.checkList.totalPages = 0;
    }
  }

  navigateTo() {
    this.router.navigateByUrl('hygiene-check-menu/new-hygiene-check');
  }

  existInProgressAudit() {
    const foundElement = this.checkList.checkList.find(item => !item.isCompleted);
    return foundElement ? true : false;
  }

  reloadCheckList() {
    this.loadCheckList();
  }

  goToPage(page: number) {
    this.page = page;
    this.loadCheckList();
  }

  onClickFilter(filter: string) {
    this.filterType = filter;
    this.page = 1;
    this.loadCheckList();
  }
}
